// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ABVNjppl2aIOdhn9EaYy {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
@media only screen and (max-width: 767px) {
  .ABVNjppl2aIOdhn9EaYy .laodw_CS9IAqEtICjNsP {
    margin-left: 16px;
  }
}
.ABVNjppl2aIOdhn9EaYy .laodw_CS9IAqEtICjNsP span {
  margin-left: 4px;
}
@media only screen and (max-width: 767px) {
  .ABVNjppl2aIOdhn9EaYy .laodw_CS9IAqEtICjNsP span {
    display: none;
  }
}

.znjBSqwxoSEGZtlCR9QE {
  max-width: 240px;
  margin-right: auto;
  font-weight: 500;
  color: #6F767E;
}
.znjBSqwxoSEGZtlCR9QE strong {
  font-weight: 600;
  color: #1A1D1F;
}
.dark-mode .znjBSqwxoSEGZtlCR9QE strong {
  color: #FCFCFC;
}

.NH7C2adv0FhFuQrE5Z4k {
  display: flex;
}

.CqTxmq5agzCMZ9EcDR28,
.K_LFh_8aCY7MD6v7WiBH {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 32px 16px;
  flex: 0 0 25%;
  text-align: center;
  color: #1A1D1F;
  transition: color 0.2s;
}
@media only screen and (max-width: 767px) {
  .CqTxmq5agzCMZ9EcDR28,
  .K_LFh_8aCY7MD6v7WiBH {
    flex: 0 0 33.333%;
    padding: 16px 8px;
  }
}
.dark-mode .CqTxmq5agzCMZ9EcDR28,
.dark-mode .K_LFh_8aCY7MD6v7WiBH {
  color: #FCFCFC;
}

.CqTxmq5agzCMZ9EcDR28:hover,
.K_LFh_8aCY7MD6v7WiBH:hover {
  color: #2A85FF;
}

.CqTxmq5agzCMZ9EcDR28 {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2307692308;
}
@media only screen and (max-width: 639px) {
  .CqTxmq5agzCMZ9EcDR28:nth-child(n+3) {
    display: none;
  }
}

.K_LFh_8aCY7MD6v7WiBH {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
}

.WpNb6M7JhY4h4Io2NNeI,
.yG1U80KH5AcrQuQ6WJOO {
  width: 64px;
  height: 64px;
  margin: 0 auto 12px;
}

.WpNb6M7JhY4h4Io2NNeI img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.yG1U80KH5AcrQuQ6WJOO {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #EFEFEF;
  border-radius: 50%;
  background: #EFEFEF;
  transition: all 0.2s;
}
.yG1U80KH5AcrQuQ6WJOO svg {
  fill: #6F767E;
  transition: fill 0.2s;
}
.dark-mode .yG1U80KH5AcrQuQ6WJOO {
  background: #272B30;
  border-color: #272B30;
}

.K_LFh_8aCY7MD6v7WiBH:hover .yG1U80KH5AcrQuQ6WJOO {
  border-color: #2A85FF;
  background: none;
}
.K_LFh_8aCY7MD6v7WiBH:hover .yG1U80KH5AcrQuQ6WJOO svg {
  fill: #2A85FF;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/Overview/Users/Users.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AADJ;ACYI;EDVA;IAEQ,iBAAA;EAAV;AACF;AAAQ;EACI,gBAAA;AAEZ;ACII;EDPI;IAGQ,aAAA;EAId;AACF;;AAHA;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cC0BC;ADpBL;AALI;EACI,gBAAA;EACA,cC0BH;ADnBL;ACgKa;EDrKD,cCkBP;ADVL;;AANA;EACI,aAAA;AASJ;;AAPA;;EAEI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cCWC;EDVD,sBAAA;AAUJ;AC/BI;EDYJ;;IAWQ,iBAAA;IACA,iBAAA;EAaN;AACF;ACsIa;;EDlJL,cCDH;ADiBL;;AAfI;;EACI,cCdH;ADiCL;;AAjBA;ECqEI,eAAA;EACA,gBAAA;EACA,yBAAA;ADhDJ;AClDI;ED6BA;IAEQ,aAAA;EAuBV;AACF;;AAtBA;EC0DI,eAAA;EACA,gBAAA;EACA,yBAAA;ADhCJ;;AAzBA;;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;AA4BJ;;AAzBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA4BR;;AA1BA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBC/BC;EDgCD,oBAAA;AA6BJ;AA5BI;EACI,aCjCH;EDkCG,qBAAA;AA8BR;ACgFa;ED5GL,mBClCH;EDmCG,qBCnCH;ADkEL;;AA3BQ;EACI,qBCxDP;EDyDO,gBAAA;AA8BZ;AA7BY;EACI,aC3DX;AD0FL","sourcesContent":["@import ../../../../styles/helpers\n\n.head\n    display: flex\n    align-items: center\n    margin-bottom: 24px\n    .button\n        +m\n            margin-left: 16px\n        span\n            margin-left: 4px\n            +m\n                display: none\n\n.info\n    max-width: 240px\n    margin-right: auto\n    font-weight: 500\n    color: $n4\n    strong\n        font-weight: 600\n        color: $n7\n        +dark\n            color: $n1\n\n.list\n    display: flex\n\n.item,\n.all\n    display: flex\n    justify-content: center\n    flex-direction: column\n    padding: 32px 16px\n    flex: 0 0 25%\n    text-align: center\n    color: $n7\n    transition: color .2s\n    +m\n        flex: 0 0 33.333%\n        padding: 16px 8px\n    +dark\n        color: $n1\n    &:hover\n        color: $p1\n\n.item\n    +caption1-m\n    &:nth-child(n+3)\n        +a\n            display: none\n\n.all\n    +caption1\n\n.avatar,\n.icon\n    width: 64px\n    height: 64px\n    margin: 0 auto 12px\n\n.avatar\n    img\n        width: 100%\n        height: 100%\n        object-fit: cover\n        border-radius: 50%\n\n.icon\n    display: flex\n    justify-content: center\n    align-items: center\n    border: 2px solid $n3\n    border-radius: 50%\n    background: $n3\n    transition: all .2s\n    svg\n        fill: $n4\n        transition: fill .2s\n    +dark\n        background: $n6\n        border-color: $n6\n\n.all\n    &:hover\n        .icon\n            border-color: $p1\n            background: none\n            svg\n                fill: $p1","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": `ABVNjppl2aIOdhn9EaYy`,
	"button": `laodw_CS9IAqEtICjNsP`,
	"info": `znjBSqwxoSEGZtlCR9QE`,
	"list": `NH7C2adv0FhFuQrE5Z4k`,
	"item": `CqTxmq5agzCMZ9EcDR28`,
	"all": `K_LFh_8aCY7MD6v7WiBH`,
	"avatar": `WpNb6M7JhY4h4Io2NNeI`,
	"icon": `yG1U80KH5AcrQuQ6WJOO`
};
export default ___CSS_LOADER_EXPORT___;
